import { useCallback, useEffect, useState } from "react";
import axios from "../../../../../../api/axios";
import InventoryPurchaseLog from "../components/InventoryPurchaseLog";
import InventoryStatusReport from "../components/InventoryStatusReport";
import {
  buildReportCsvFileName,
  createInventoryReportCsvRows,
  downloadCsvFromJson,
} from "../utils/csvExport";

const emptyInventoryReportData = {
  inventoryStatus: [],
  inventoryPurchaseLog: [],
};

const restaurantIdFrom = (reportContext) =>
  reportContext?.businessEntityId ||
  reportContext?.business_entity_id ||
  sessionStorage.getItem("configBizEntityId");

const AdvanceInventory = ({ reportContext }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [reportData, setReportData] = useState(emptyInventoryReportData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const restaurantId = restaurantIdFrom(reportContext);

  const fetchReport = useCallback(async () => {
    if (!restaurantId) {
      setError("Restaurant is required.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.get("/reports/getInventoyReport", {
        params: { restaurantId },
      });
      setReportData({ ...emptyInventoryReportData, ...response.data });
    } catch (err) {
      console.error("Error fetching Advanced Inventory report:", err);
      setError("Failed to fetch Advanced Inventory report.");
    } finally {
      setLoading(false);
    }
  }, [restaurantId]);

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);

  const tabs = [
    {
      label: "Inventory Status",
      exportRows: createInventoryReportCsvRows("Inventory Status", reportData),
      content: (
        <InventoryStatusReport
          rows={reportData.inventoryStatus}
          loading={loading}
        />
      ),
    },
    {
      label: "Inventory Purchase Log",
      exportRows: createInventoryReportCsvRows("Inventory Purchase Log", reportData),
      content: (
        <InventoryPurchaseLog
          rows={reportData.inventoryPurchaseLog}
          loading={loading}
        />
      ),
    },
  ];

  const handleDownloadReport = () => {
    const selectedReport = tabs[selectedTab];
    const fileName = buildReportCsvFileName({
      businessName: reportContext?.businessName,
      productName: reportContext?.productName,
      reportName: selectedReport.label,
      includeDateRange: false,
    });

    downloadCsvFromJson(selectedReport.exportRows, fileName);
  };

  return (
    <div className="product-report-tabs">
      <div className="product-report-title">
        <div>
          <span>{reportContext?.businessName}</span>
          <strong>{reportContext?.productName}</strong>
        </div>
        <div className="report-filter-bar">
          <button type="button" onClick={fetchReport} disabled={loading}>
            {loading ? "Loading..." : "Refresh Report"}
          </button>
          <button
            type="button"
            className="report-download-btn"
            onClick={handleDownloadReport}
            disabled={loading}
          >
            Download CSV
          </button>
        </div>
      </div>

      {error && <div className="report-error">{error}</div>}

      <div className="product-report-tab-list inventory-report-tab-list">
        {tabs.map((tab, index) => (
          <button
            key={tab.label}
            type="button"
            className={`product-report-tab ${
              selectedTab === index ? "selected" : ""
            }`}
            onClick={() => setSelectedTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="product-report-tab-panel">{tabs[selectedTab].content}</div>
    </div>
  );
};

export default AdvanceInventory;
